import type {
  CommonResponseSlicePaperResponse,
  PaperResponseV2,
} from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'
import { mapSliceContent, type Slice, sliceSchema } from '~/schema/slice'

import { type CreatedPaper, CreatedPaperSchema, type Paper, PaperSchema } from './schemas'

const ENTITY = 'Paper'

// 스펙이 Kotlin nullable 을 optional 로만 그린 곳. 서버는 키를 빼지 않고 null 을 싣는다 — 자료의 학교·시험 정보
// (schoolName·schoolCode·schoolTestYear·schoolTestType), 박스의 topicId·subTopicId. 2026-10-13 백엔드
// develop(cc5f60e17) 의 paper/controller/response/PaperResponse.kt·PaperResponseV2.kt, paper/model/dto/PaperBox.kt
// 로 확인.

export const adaptPapers = (raw: CommonResponseSlicePaperResponse['data']): Slice<Paper> =>
  mapSliceContent(parseApiResponse(sliceSchema(PaperSchema), raw, ENTITY), (paper) => paper)

export const adaptCreatedPaper = (raw: PaperResponseV2): CreatedPaper =>
  parseApiResponse(CreatedPaperSchema, raw, ENTITY)
